import styled from 'styled-components';
import { Clickable } from 'foundations-components/transitional/components/Clickable';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledSelectionPanelButton = styled.div.withConfig({
  displayName: "SelectionPanelButton__StyledSelectionPanelButton",
  componentId: "sc-1dmo3zy-0"
})(["padding:", ";color:", ";:hover{background-color:", ";}"], ({
  theme
}) => `${theme.space['200']} ${theme.space['250']} ${theme.space['200']} ${theme.space['1000']}`, ({
  $disabled,
  theme
}) => $disabled ? theme.color['text-primary-disabled'] : 'inherit', ({
  $disabled,
  theme
}) => $disabled ? 'transparent' : theme.color['fill-tertiary-default']);
export default function SelectionPanelButton({
  children,
  disabled,
  onClick
}) {
  return /*#__PURE__*/_jsx(Clickable, {
    onClick: onClick,
    disabled: disabled,
    children: /*#__PURE__*/_jsx(StyledSelectionPanelButton, {
      $disabled: disabled,
      children: children
    })
  });
}